import React, {useEffect} from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";

const ImageSidebarItem = ({imageDetail, setSelectedImage}) => {
    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 100,
        width: 100,
        backgroundColor: 'bg-white',
    };

    let important = {
        backgroundImage: `url("${imageDetail?.thumbnail}")`,
        backgroundSize: size,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
    };

    const handleDragStart = (event) => {
        setSelectedImage(imageDetail);
    }

    return (
        <>
            <div className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                <div style={{...defaults, ...important}}
                     draggable="true"
                     onDragStart={handleDragStart}/>
            </div>
        </>
    )
}

export default ImageSidebarItem
